/*/
 * Anchor
 *
 * Target: href | data-target
 * Align:  start | center | end | nearest
 *
/*/
	const siteAnchor = document.querySelectorAll('[site-anchor-load]')

	if (siteAnchor) {
		siteAnchor.forEach(e => {
			e.addEventListener('click', _ => {
				_.preventDefault()

				const dataTarget = e.dataset.target
				const targetCheck = document.querySelector(dataTarget)

				if (dataTarget && targetCheck) {
					const modalOpen = document.querySelector('.modal.show')

					if (modalOpen) {
						modalOpen.querySelector('.nav--modal_close').click()
						document.documentElement.classList.remove('is--nav')

						setTimeout(() => {
							targetCheck.focus()
							document.querySelector(dataTarget).scrollIntoView({
								behavior: 'smooth',
								block: 'start',
								inline: 'nearest'
							})
						}, 500);
					} else {
						document.querySelector(dataTarget).scrollIntoView({
							behavior: 'smooth',
							block: 'start',
							inline: 'nearest'
						})
					}

				} else {
					window.localStorage.setItem('site_scroll_to', dataTarget)

					setTimeout(() => {
						window.location = e.href
					}, 100)
				}
			})
		})
	}

	window.addEventListener('load', function () {
		const target = window.localStorage.getItem('site_scroll_to')
		if (target && document.querySelector(target)) {
			setTimeout(() => {
				document.querySelector(target).scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'nearest'
				})
			}, 1000)

			setTimeout(() => {
				window.localStorage.removeItem('site_scroll_to')
			}, 100)
		}
	})
